import moment from "moment/moment";

export default function CompLeaveReqsCollection(getApplication, intl, page) {
    let reqRecords = []
    const statusIntl = 'status.';

    if(getApplication.length > 0) {
        for (var i = 0; i < getApplication.length; i++) {
            const dateSubmitted = new Date(getApplication[i].created_at);
            switch (page) {
                case 'CompLeaveReqs':
                    reqRecords.push({
                        id: `${getApplication[i].id}`,
                        dataSubmitted: dateSubmitted.toLocaleString(),
                        period: `${getApplication[i].period}`,
                        totalHours: `${getApplication[i].hours}`,
                        status: `${intl.formatMessage({ id: statusIntl + getApplication[i].status })}`,

                    });
                    break
                case 'Balance':
                    reqRecords.push({
                        id: `${getApplication[i].id}`,
                        dataSubmitted: `${getApplication[i].date_request}`,
                        expiryDate: `${getApplication[i].expire_date}`,
                        description: `${getApplication[i].description}`,
                        earn: `${getApplication[i].earn}`,
                        used: `${getApplication[i].used}`,
                        expired: `${getApplication[i].expired}`,
                        remaining: `${getApplication[i].remaining}`,
                        cashOut: `${getApplication[i].cash_out}`
                    });
                    break
            }

        }
    }
    return reqRecords;
}
